import './assets/css/bootstrap.min.css';
import './assets/css/LineIcons.css';
import './assets/css/magnific-popup.css';
import './assets/css/default.css';
import './assets/css/style.css';
